import {Text, Stack, Alert} from "@mantine/core";
import {Artifact} from "../../../../types";
import {useTranslation} from "react-i18next";

interface FallbackRendererProps {
    artifact: Artifact;
}

export function FallbackRenderer({artifact}: FallbackRendererProps) {
    const {t} = useTranslation();
    const llmSummary = (artifact.payload as Record<string, unknown>)
        ?.llmSummary as string | undefined;

    console.error(`Ukjent artefakttype: ${artifact.type}`);

    return (
        <Alert variant="light" color="red" title={t("contextSidebar.error")}>
            <Stack gap="xs">
                {llmSummary && <Text size="sm">{llmSummary}</Text>}
                {!llmSummary && (
                    <Text size="sm" c="dimmed">
                        {t("Error.UnknownArtifact")}
                    </Text>
                )}
            </Stack>
        </Alert>
    );
}
